// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"564d7f65","463":"d941bc9d","572":"e1e9930d","574":"e56d7451","937":"a249b0b5"}[chunkId] + ".chunk.css";
};